import { render } from "./importar.vue?vue&type=template&id=2f654ee0"
import script from "./importar.vue?vue&type=script&lang=js"
export * from "./importar.vue?vue&type=script&lang=js"

import "./importar.vue?vue&type=style&index=0&id=2f654ee0&lang=scss"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__